import { SanityKpiBlock } from '../../types/generated/graphql-types'
import { KpiBlockProps } from '../components/blocks/KpiBlock'
import { notEmpty } from '../utilities/filters'

export const sanityKpiBlockToKpiBlockProps = ({
  footnotes,
  lastUpdate,
  kpiClasses,
}: SanityKpiBlock): KpiBlockProps => ({
  footnotes: footnotes?.filter(notEmpty),
  lastUpdate: lastUpdate ?? new Date().toISOString(),
  kpiClasses:
    kpiClasses?.filter(notEmpty).map(item => ({
      name: item.name ?? '',
      kpiValues:
        item.kpiValues?.filter(notEmpty).map(kpiValue => ({
          title: kpiValue.title ?? '',
          value: kpiValue.value ?? '',
        })) ?? [],
    })) ?? [],
})
